import styled, { css } from "styled-components";
import palette from "../../lib/styles/palette";
import { useState } from "react";

import ConveyorSummary from "./summary/ConveyorSummary";
import DriveSummary from "./summary/DriveSummary";
import PulleySummary from "./summary/PulleySummary";


const ConveyorViewer = ({ conveyor, error, loading, actionButtons }) => {
    const [tab, setTab] = useState('summary');

    // 에러 발생 시
    if (error) {
        if (error.message && error.response.status === 404) {
            return <ConveyorViewerBlock>Not Existing Conveyor!!!</ConveyorViewerBlock>
        }
        return <ConveyorViewerBlock>Unknown Error!!!</ConveyorViewerBlock>
    }
    
    // 로딩 중이거나 아직 컨베이어가 없을 때
    if (loading || !conveyor) {
        return null;
    }

    const { title, body } = conveyor;

    return (
        <ConveyorViewerBlock>
            <Title>Conveyor Viewer / {title}</Title>
                {actionButtons}
                <Nav>
                    <Tab onClick={() => setTab('summary')} isSelected={tab === 'summary'} >Summary</Tab>
                    <Tab onClick={() => setTab('drive')} isSelected={tab === 'drive'} >Drive(s)</Tab>
                    <Tab onClick={() => setTab('pulley')} isSelected={tab === 'pulley'} >Pulley</Tab>
                    <Tab onClick={() => setTab('component')} isSelected={tab === 'component'} >Component</Tab>
                    <Tab onClick={() => setTab('dynamics')} isSelected={tab === 'dynamics'} >Dynamics</Tab>
                    <Tab onClick={() => setTab('structure')} isSelected={tab === 'structure'} >Structure</Tab>
                    {/* <Tab onClick={() => setTab('output')}>Output</Tab> */}
                    {/* <Tab onClick={() => setTab('details')}>All Details</Tab> */}
                </Nav>
                <Body>
                    {tab === 'summary' && <ConveyorSummary body={body} />}
                    {tab === 'drive' && <DriveSummary body={body} />}
                    {tab === 'pulley' && <PulleySummary pulleys={body.pulleys} />}
                    {/* {tab === 'structure' && <StructureSummary conveyor={conveyor} />} */}
                    {/* {tab === 'structure' && <StructureViewerContainer />} */}
                    {/* {tab === 'details' && <ConveyorDetail body={body} />} */}

                </Body>
        </ConveyorViewerBlock>
    );
};

export default ConveyorViewer;


/* =================   Styles   ================== */
const ConveyorViewerBlock = styled.div`
    width: 100%;
    max-width: 1280px;
    min-width: 800px;
    margin: 0 auto;
`;

const Title = styled.div`
    font-size: 1.125rem;
    font-weight: 500;
    // margin-bottom: 1rem;
`;

const Nav = styled.ul`
    display: flex;
    margin-top: 2rem;
    margin-bottom: 2rem;
`;

const Tab = styled.li`
    width: 100px;
    background-color: ${palette.yachtBlue};
    color: white;
    text-align: center;
    padding: 0.25rem 0.25rem 0.35rem;

    & + & {
        margin-left: 0.5rem;
    }
    &:hover {
        background-color: #fff;
        border: ${palette.yachtBlue};
        color: ${palette.yachtBlue};
        cursor: pointer;
        transition: 0.3s;
    }

    @media(max-width: 1280px) {

    }
    @media (max-width: 980px) {
        display: none;
    }

    ${(props) => 
        props.isSelected &&
        css`
            background-color: transparent;
            color: ${palette.yachtBlue};
            font-weight: 500;
        `
    }
`;

const Body = styled.div`

`;
